/**
 * Conditional Color Variant Picker
 *
 * Shows/hides Color/Colours variant option based on Finish selection.
 * Color options only appear when "Painted (powdercoated)" is selected.
 *
 * When Weathering Steel is selected:
 * - Auto-select the "-" color variant (hidden placeholder)
 * - Hide the color picker visually
 */

document.addEventListener('DOMContentLoaded', () => {
  initConditionalColorVariants();
});

// Re-initialize when new content is loaded
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver((mutations) => {
    let shouldInit = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && (node.matches?.('variant-selects') || node.querySelector?.('variant-selects'))) {
            shouldInit = true;
            break;
          }
        }
      }
      if (shouldInit) break;
    }
    if (shouldInit) {
      initConditionalColorVariants();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function initConditionalColorVariants() {
  document.querySelectorAll('variant-selects:not([data-color-conditional-init])').forEach(variantSelects => {
    variantSelects.setAttribute('data-color-conditional-init', 'true');

    const finishKeywords = ['powder', 'painted', 'powdercoat'];
    const colorOptionNames = ['color', 'colour', 'colors', 'colours'];
    const finishOptionNames = ['finish', 'finishes'];

    const findOptionByNames = (names) => {
      const options = variantSelects.querySelectorAll('.product-form__input, .variant-option');
      for (const option of options) {
        const legend = option.querySelector('legend, label.form__label');
        if (!legend) continue;

        const optionName = legend.textContent.toLowerCase().replace(':', '').trim();
        if (names.some(name => optionName.includes(name))) {
          return option;
        }
      }
      return null;
    };

    const finishOption = findOptionByNames(finishOptionNames);
    const colorOption = findOptionByNames(colorOptionNames);

    if (!finishOption || !colorOption) return;

    // Track state
    let lastRealColor = null;

    const getSelectedFinishValue = () => {
      const checkedRadio = finishOption.querySelector('input[type="radio"]:checked');
      if (checkedRadio) return checkedRadio.value.toLowerCase();

      const select = finishOption.querySelector('select');
      if (select) return select.value.toLowerCase();

      return '';
    };

    const isPowdercoatedSelected = () => {
      const value = getSelectedFinishValue();
      return finishKeywords.some(keyword => value.includes(keyword));
    };

    const getCurrentColorValue = () => {
      const checkedColor = colorOption.querySelector('input[type="radio"]:checked');
      return checkedColor ? checkedColor.value : null;
    };

    const clickColorInput = (input) => {
      if (input && !input.checked) {
        // Click the label instead of the input for proper Shopify handling
        const label = colorOption.querySelector(`label[for="${input.id}"]`);
        if (label) {
          label.click();
        } else {
          input.click();
        }
      }
    };

    const showColors = () => {
      colorOption.style.display = '';
      colorOption.classList.remove('conditional-hidden');
      colorOption.classList.add('conditional-visible');

      // Restore last real color or select first available
      setTimeout(() => {
        const current = getCurrentColorValue();

        // Only change if currently on "-"
        if (current === '-') {
          if (lastRealColor) {
            const targetInput = colorOption.querySelector(`input[type="radio"][value="${CSS.escape(lastRealColor)}"]`);
            if (targetInput && !targetInput.classList.contains('disabled')) {
              clickColorInput(targetInput);
            } else {
              const firstReal = colorOption.querySelector('input[type="radio"]:not([value="-"]):not(.disabled)');
              if (firstReal) clickColorInput(firstReal);
            }
          } else {
            const firstReal = colorOption.querySelector('input[type="radio"]:not([value="-"]):not(.disabled)');
            if (firstReal) clickColorInput(firstReal);
          }
        }
      }, 50);
    };

    const hideColors = () => {
      // Store current color before hiding (if not "-")
      const current = getCurrentColorValue();
      if (current && current !== '-') {
        lastRealColor = current;
      }

      colorOption.style.display = 'none';
      colorOption.classList.remove('conditional-visible');
      colorOption.classList.add('conditional-hidden');

      // Select "-" by clicking it
      setTimeout(() => {
        const dashInput = colorOption.querySelector('input[type="radio"][value="-"]');
        if (dashInput && !dashInput.checked) {
          clickColorInput(dashInput);
        }
      }, 50);
    };

    const handleFinishChange = () => {
      if (isPowdercoatedSelected()) {
        showColors();
      } else {
        hideColors();
      }
    };

    // Set initial state on page load (after a small delay to let Shopify settle)
    setTimeout(() => {
      handleFinishChange();
    }, 50);

    // Listen ONLY to finish option changes
    finishOption.addEventListener('change', () => {
      setTimeout(() => {
        handleFinishChange();
      }, 50);
    });
  });
}
